const ExtractTextFromHTML = (html) => {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // ✅ Add class to <li>
  doc.querySelectorAll("li").forEach((li) => {
    li.classList.add("my-custom-li");
  });

  // ✅ Remove <p> but keep content
  doc.querySelectorAll("p").forEach((p) => {
    const parent = p.parentNode;

    while (p.firstChild) {
      parent.insertBefore(p.firstChild, p);
    }

    parent.removeChild(p);
  });

  // ✅ Replace &nbsp; and actual non-breaking space characters
  let output = doc.body.innerHTML;
  output = output.replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ");

  return output;
};

export default ExtractTextFromHTML;